<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('afterdeparture.Arrival_UBN') }}</h5>
    <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="row mt-3">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('mating.UBN') }} *</label>
                <select id="arrivalUbnId" v-model="localFormData.arrivalUbnId" class="form-control form-control-default">
                    <option value="">{{ $t('mating.Select_UBN') }}</option>
                    <option v-for="item in ubns" :key="item.id" :value="item.id">
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                    </option>
                </select>
                <span v-if="v$.arrivalUbnId.$error" class="text-sm text-danger">
                    {{ v$.arrivalUbnId.$errors[0].$message }}
                </span>
            </div>            
          </div>
        </div>          
      </div>      
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto mb-0 js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { computed, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: "ArrivalUBN",

  props: {
    formData: {
      type: Object,
      required: true
    },
    nextStep: Function,
    ubns: {
      type: Array,
      default: () => []
    },
    animals: {
      type: Array,
      default: () => []
    },
    emitter: Object
  },

  setup(props, { emit }) {

    const { t } = useI18n()

    const localFormData = reactive({
      associationId: props.formData.associationId,
      arrivalUbnId: props.formData.arrivalUbnId,
      ubn: props.formData.ubn,
      ubnId: props.formData.ubnId
    })

    const rules = computed(() => ({
      arrivalUbnId: {
        required: helpers.withMessage(t('common.Required'), required),
        isSelected: helpers.withMessage(t('common.Select_a_ubn'), value => value !== '')
      }
    }))

    const v$ = useVuelidate(rules, localFormData)

    // Keep local data in sync when parent changes it
    watch(
      () => props.formData.associationId,
      (newVal) => {
        localFormData.associationId = newVal
      },
      { immediate: true }
    )

    watch(
      () => props.formData.ubn,
      (newVal) => {
        localFormData.ubn = newVal
      },
      { immediate: true }
    )

    watch(
      () => props.formData.ubnId,
      (newVal) => {
        localFormData.ubnId = newVal
      },
      { immediate: true }
    )

    watch(
      () => props.formData.arrivalUbnId,
      (newVal) => {
        localFormData.arrivalUbnId = newVal
      },
      { immediate: true }
    )
    
    watch(
      () => localFormData.arrivalUbnId,
      (newVal) => {
        emit('update:formData', {
          arrivalUbnId: newVal
        })
      }
    )

    const validateAndNextStep = async () => {
      v$.value.$touch()

      if (v$.value.$pending) {
        await v$.value.$validate()
      }

      if (!v$.value.$invalid) {
        emit('request-animals', {
          associationId: localFormData.associationId,
          arrivalUbnId: localFormData.arrivalUbnId
        })
      }
    }

    return {
      localFormData,
      v$,
      validateAndNextStep
    }
  },

  computed: {
    userRoleName() {
      return this.$store.state.user?.roleName
    }
  }
}
</script>